import React, { useEffect } from 'react';
import { motion, useAnimation } from "framer-motion";
import { useInView } from "react-intersection-observer";

const SkillTitle = ({ activeSkill }) => {
    const controls = useAnimation();
    const [ref, inView] = useInView({ triggerOnce: true });

    useEffect(() => {
        if (inView) {
            controls.start("visible");
        }
    }, [inView, controls]);

    useEffect(() => {
        controls.start(activeSkill ? "activeSkillOff" : "activeSkillOn");
    }, [activeSkill, controls]);

    const variants = {
        hidden: { 
            y: 50, 
            opacity: 0 
        },
        visible: {
            y: 0,
            opacity: 1,
            transition: { duration: 0.5, ease: "easeInOut" },  // Removed delay
        },
        activeSkillOn: {
            opacity: 1,
            pointerEvents: "none",
            transition: { duration: 0.3 }
        },
        activeSkillOff: {
            opacity: 0,
            pointerEvents: "all",
            transition: { duration: 0.3 }
        }
    };

    return (
        <motion.h1
            ref={ref}
            className="section-title"
            initial="hidden"
            animate={controls}
            variants={variants}
        >
            Skillset <span className="line-break">for your needs</span>
        </motion.h1>
    );
};

export default SkillTitle;